import { useTranslation } from "react-i18next";
import { BeeMark, Icon, ThemeToggle } from "./ui";
import { useAppConfig } from "../../config/AppConfigContext";

/**
 * Shown to everyone but admins while the admin has maintenance mode on.
 * Admins keep full access — that is how they turn it back off.
 */
export default function MaintenanceScreen({
  theme, onThemeChange,
}: {
  theme: "dark" | "light";
  onThemeChange: (t: "dark" | "light") => void;
}) {
  const { t, i18n } = useTranslation();
  const { config } = useAppConfig();
  const isRu = !i18n.language?.startsWith("en");

  const message =
    (isRu ? config.maintenance_message_ru : config.maintenance_message_en) ||
    t("maintenance.body");
  const handle = config.contact_handle;

  return (
    <div className="beeapp__scroll">
      <div className="wrap" style={{ minHeight: "100%", display: "grid", placeItems: "center" }}>
        <div style={{ position: "absolute", top: 14, right: 14 }}>
          <ThemeToggle theme={theme} onThemeChange={onThemeChange} />
        </div>
        <div className="glass glass-lg anim-rise" style={{ padding: 28, maxWidth: 420, textAlign: "center" }}>
          <div style={{ display: "grid", placeItems: "center", marginBottom: 16 }}>
            <BeeMark size={54} />
          </div>
          <h1 className="t-title" style={{ marginBottom: 10 }}>{t("maintenance.title")}</h1>
          <p className="t-body muted" style={{ lineHeight: 1.5 }}>{message}</p>
          {handle && (
            <a
              href={`https://t.me/${handle}`}
              target="_blank"
              rel="noreferrer"
              className="btn btn-glass btn-block"
              style={{ marginTop: 18, textDecoration: "none" }}
            >
              <Icon name="message" size={18} /> @{handle}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
